<template>
    <div>
        <MeasurementItem
            v-if="adBlueLevel"
            :title="adBlueLevel.title"
            :datetime="adBlueLevel.lastUpdated"
            :link-to="adBlueLevel.link"
        >
            <template #icon>
                <FuelCanIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('shared.measurements.adblue_level') }}:

                <h3 class="sensor-data-percentage">
                    {{ adBlueLevel.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="evBatteryPercentage"
            :title="evBatteryPercentage.title"
            :datetime="evBatteryPercentage.lastUpdated"
            :link-to="evBatteryPercentage.link"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-level-in-percent="evBatteryPercentage.value"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.ev_battery_percentage') }}:

                <h3 class="sensor-data-percentage">
                    {{ evBatteryPercentage.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="evBatteryHealth"
            :title="evBatteryHealth.title"
            :datetime="evBatteryHealth.lastUpdated"
            :link-to="evBatteryHealth.link"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-level-in-percent="evBatteryHealth.value"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.ev_battery_health') }}:

                <h3 class="sensor-data-percentage">
                    {{ evBatteryHealth.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="evChargingState"
            :title="evChargingState.title"
            :datetime="evChargingState.lastUpdated"
            :link-to="evChargingState.link"
        >
            <template #icon>
                <FilledCircleIcon
                    width="24"
                    height="24"
                    :class="evChargingState.value ? 'green' : 'red'"
                />
            </template>

            <template #content>
                <h3 class="measurement-value">
                    {{
                        evChargingState.value
                            ? $t('charging')
                            : $t('chargingNot')
                    }}
                </h3>
            </template>
        </MeasurementItem>

        <EvChargingEtaMeasurementItem
            v-if="evChargingState && evChargingState.value && evChargingEta"
            :measurement="evChargingEta"
        />
    </div>
</template>

<script>
import BatteryIcon from './icons/BatteryIcon'
import EvChargingEtaMeasurementItem from './EvChargingEtaMeasurementItem'
import FilledCircleIcon from './icons/FilledCircleIcon'
import FuelCanIcon from './icons/FuelCanIcon'
import MeasurementItem from './MeasurementItem'
import MeasurementListHelper from '../mixins/MeasurementListHelper'

export default {
    name: 'TruckMeasurement',
    components: {
        BatteryIcon,
        EvChargingEtaMeasurementItem,
        FilledCircleIcon,
        FuelCanIcon,
        MeasurementItem,
    },
    mixins: [MeasurementListHelper],
    computed: {
        adBlueLevel() {
            return this.getMeasurementItem('adblue_level')
        },
        evBatteryHealth() {
            return this.getMeasurementItem('ev_battery_health')
        },
        evBatteryPercentage() {
            return this.getMeasurementItem('ev_battery_percentage')
        },
        evChargingEta() {
            return this.getMeasurementItem('ev_charging_eta')
        },
        evChargingState() {
            return this.getMeasurementItem('ev_charging_state')
        },
        speed() {
            return this.getMeasurementItem('speed')
        },
    },
}
</script>

<i18n>
{
    "en": {
        "charging": "Charging",
        "chargingEta": "Charging finished at {0}",
        "chargingNot": "Not charging"
    },
    "de": {
        "charging": "Aufladend",
        "chargingEta": "EV Ladung fertig am {0}",
        "chargingNot": "Nicht aufladend"
    },
    "fr": {
        "charging": "Chargement",
        "chargingEta": "Charge terminée à {0}",
        "chargingNot": "Pas de charge"
    },
    "it": {
        "charging": "Ricarica",
        "chargingEta": "Ricarica completata alle {0}",
        "chargingNot": "Non in carica"
    }
}
</i18n>

<style lang="scss" scoped>
.measurement-value {
    padding-bottom: 2px;
    padding-left: 0;
    font-size: 20px;
}

.green {
    color: $color-green;
}

.red {
    color: $color-red;
}
</style>
